import { useSelector } from "react-redux";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";
import {
  INTERCEPTOR_TRIGGERS,
  INTERCEPTOR_TRIGGER_IDS,
} from "../../../../utils/interceptorTriggers";
import {
  buildInterceptorExtraData,
  filterInterceptorField,
} from "../interceptor/shared";

const FORM_CODE = "interceptorExitModelCatalog";
const TRIGGER_INFO =
  INTERCEPTOR_TRIGGERS[INTERCEPTOR_TRIGGER_IDS.exitModelCatalog].info;

export default function InterceptorExitModelCatalog() {
  const { cityName } = useSelector((state) => state.location);
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.triggerTryExitOpen}
      goalSent={GOALS.triggerTryExitSent}
      filterField={filterInterceptorField}
      extraData={buildInterceptorExtraData({ info: TRIGGER_INFO, cityName })}
    />
  );
}
